import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import "./Navbar.css";

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHomeTop = location.pathname === "/" && !isScrolled;

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 24);
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <nav className={`navbar ${isHomeTop ? "transparent" : "scrolled"}`}>
      <div className="container nav-container">
        <Link to="/" className="brand" aria-label="ThinkRise USA Home">
          <picture>
            <source media="(max-width: 1000px)" srcSet="/thinklogo1.png" />
            <img src="/thinklogo1.png" alt="ThinkRise USA logo" className="brand-logo" />
          </picture>
        </Link>

        <div className="brand-center" aria-hidden="true">
          ThinkRise <strong>USA</strong>
        </div>

        <button
          className="mobile-menu-btn"
          onClick={() => setIsMobileMenuOpen((v) => !v)}
          aria-label={isMobileMenuOpen ? "Close menu" : "Open menu"}
        >
          {isMobileMenuOpen ? <FaTimes size={20} /> : <FaBars size={20} />}
        </button>

        <div className={`nav-links ${isMobileMenuOpen ? "active" : ""}`}>
          <Link to="/" className="nav-link">Home</Link>
          <Link to="/about" className="nav-link">About</Link>
          <Link to="/why-thinkrise-usa" className="nav-link">Why ThinkRise USA</Link>
          <Link to="/solutions" className="nav-link">Solutions</Link>
          <Link to="/products-industries" className="nav-link">Products and Industries</Link>
          <Link to="/resources" className="nav-link">Resources</Link>
          <Link to="/contact" className="nav-link nav-cta">Contact</Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
